<template>
  <page-template>
    <template slot="page-content">
      <div class="lineup--template schedule--template relative">
        <!-- PAGE BG -->
        <div class="db fixed top-0 bottom-0 w-100 vh-100 bg-cream z-2"></div>
        <!--
          <div v-if="page.background_color" class="db fixed top-0 bottom-0 w-100 vh-100 z-2" :style="{opacity: (1.0 - bgOpaciy), 'background-color': page.background_color }"></div>
          <div v-else class="db fixed top-0 bottom-0 w-100 vh-100 bg-blue z-2" :style="{opacity: (1.0 - bgOpaciy), 'background-color': '#A6CBCB' }"></div>
        -->
        <div
          class="dn db-ns fixed top-0 bottom-0 w-100 vh-100 bg-cream-pink-split-before z-3 before-ml24-ns top-0-ns"
        ></div>

        <div
          class="db dn-ns absolute is-black z-4000 bg-cream mobile-menu-lineup"
        >
          <div
            class="relative flex flex-row items-center w-100 h3 bb-grey container-fluid"
          >
            <div class="flex w-100 flex-row justify-between">
              <a
                class="f25px is-tablet-cond-bold is-black pointer"
                :href="lineup_nav_links_published[activeItemIndex].link"
                :title="lineup_nav_links_published[activeItemIndex].title"
                >{{ lineup_nav_links_published[activeItemIndex].title }}</a
              >
              <a
                class="w2 mt2 inline-flex pointer arrow-down-icon"
                :class="{ 'is-clicked': mobileMenuIconIsClicked }"
                @click="mobileMenuIconIsClicked = !mobileMenuIconIsClicked"
              >
                <simple-svg
                  class="green-arrow"
                  :filepath="'/uploads/plus.svg'"
                  :id="'arrow-down-icon-id'"
                >
                </simple-svg>
              </a>
            </div>
          </div>
          <transition name="slide-fade-rev">
            <div
              class="absolute bg-cream w-100 z-4000"
              v-show="mobileMenuIconIsClicked"
            >
              <div
                class="relative flex flex-row items-center w-100 h3 container-fluid"
                v-for="(item, index) in lineup_nav_links_published"
                v-if="index != activeItemIndex"
                :key="item.title"
              >
                <a
                  class="f25px is-tablet-cond-bold is-black pointer"
                  @click="
                    (activeItemIndex = index),
                      (mobileMenuIconIsClicked = !mobileMenuIconIsClicked)
                  "
                  :href="item.link"
                  :title="item.title"
                  >{{ item.title }}</a
                >
              </div>
            </div>
          </transition>
        </div>

        <!-- LINEUP MENU -->
        <div class="relative">
          <div class="relative z-content">
            <section class="relative mw12 flex flex-row z-1">
              <!-- MOBILE -->
              <div class=" w-100 dn-ns" v-if="isWindowWidthMobile == true">
                <div class="container-fluid  relative z-4 overflow-hidden">
                  <!-- Lineup nav -->
                </div>
              </div>
              <!-- DESKTOP -->
              <div
                class="dn relative flex-ns flex-grow-1"
                v-if="isWindowWidthMobile == false"
              >
                <div class="w-100 mw-24rem pv5 pl5 minh-450">
                  <div class="h-100">
                    <div class="info-bg sticky-nav">
                      <div class="pr5">
                        <div
                          class="pv2"
                          v-for="(item, key) in page.lineup_nav.links"
                          v-if="item.is_published"
                        >
                          <accordion
                            :index="key"
                            :desktopActive.sync="desktopActive"
                          >
                            <template slot="parent-nav-link">
                              <!-- LINEUP NAV LINK-->
                              <a
                                :class="{ active: desktopActive == key }"
                                class="f25px is-tablet-cond-bold is-black"
                                :href="item.link"
                                >{{ item.title }}</a
                              >
                            </template>
                            <!-- 
                            <template slot="sub-nav-links">
                              <div v-for="questions in faq_topic.faqs">
                                <div @click="scrollMeTo(questions.question)" class="db mv3 pv1 f15px is-black no-underline pointer" to="questions">
                                  {{  questions.question }}
                                </div>
                              </div>
                            </template> -->
                          </accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 is-black">
                  <div
                    class="ph6 mv5 b--is-orange bl bw1 z-4 relative negitive-margin"
                  >
                    <div class="z-4 relative">
                      <div
                        class="relative vh-100"
                        v-if="isWindowWidthMobile == false"
                      >
                        <p class="is-tablet-bold f4 is-black">
                          Build Your Schedule in the Outside Lands App available
                          on
                          <a
                            class="is-orange"
                            href="https://apps.apple.com/us/app/outside-lands/id547295030"
                            target="_blank"
                            >iOS</a
                          >
                          and
                          <a
                            class="is-orange"
                            href="https://play.google.com/store/apps/details?id=com.livestyled.outsidelands"
                            target="_blank"
                            >Android</a
                          >
                        </p>
                        <div
                          id="dostuff-embed-container"
                          ref="embedContainer"
                          class="w-100"
                        >
                          <div id="ds-fest"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div
            class="db dn-ns fixed top-0 bottom-0 w-100 vh-100 bg-cream-tan-split-before z-3"
            :style="{ top: 21 * lineup_nav_links_published.length + 'px' }"
          ></div>
          <div class="db dn-ns relative container-fluid z-content">
            <div class="relative pv5 vh-50">
              <p class="is-tablet-bold f4 is-black">
                Build Your Schedule in the Outside Lands App available on
                <a
                  class="is-orange"
                  href="https://apps.apple.com/us/app/outside-lands/id547295030"
                  target="_blank"
                  >iOS</a
                >
                and
                <a
                  class="is-orange"
                  href="https://play.google.com/store/apps/details?id=com.livestyled.outsidelands"
                  target="_blank"
                  >Android</a
                >
              </p>
              <div
                id="dostuff-embed-container"
                ref="embedContainer"
                class="w-100"
              >
                <div id="ds-fest"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import Accordion from "./accordion.vue";

export default {
  components: {
    PageTemplate,
    Accordion
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: titleChunk => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.seo_description
        }
      ]
    };
  },
  data() {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax: null,
      parallax2: true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      desktopActive: 0,
      mobileActive: -1,
      mobileMenuIconIsClicked: false,
      activeItemIndex: 0,
      previewLink:
        "https://osl-2020.dostff.co/embeds/schedule.js?preview_token=ab186f6a47f16141e12d",
      liveLink: "https://osl-2020.dostff.co/embeds/schedule.js"
    };
  },
  computed: {
    page: function() {
      var pageData = this.$store.getters.filterPagesByName("schedule.markdown");
      return pageData[0];
    },
    lineup_nav_links_published: function() {
      var lineup_nav_links_published = this.page.lineup_nav.links.filter(
        function(item) {
          if (item.is_published === true) {
            //console.log('item: ', item);
            return item;
          }
        }
      );
      //console.log(lineup_nav_links_published);
      return lineup_nav_links_published;
    }
  },
  methods: {
    scrollBg: function() {
      if (window.scrollY > this.bgScrollStart) {
        //console.log('scrollBg', window.scrollY, this.bgOpaciy);
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = window.scrollY * 0.001;
            //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          } else {
            this.bgOpacity = 0;
          }
        } else {
          this.bgOpaciy = window.scrollY * 0.001;
          //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = document.body.getBoundingClientRect().top;
      } else {
        this.bgOpaciy = 0;
      }
    },
    sizing: function() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
      this.scrollBg();
      //if(this.swiper)
      //this.swiper.update();
    }
  },
  created() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    if (this.window.width < 768) this.isWindowWidthMobile = true;
    else this.isWindowWidthMobile = false;

    window.addEventListener("load", this.sizing);
    window.addEventListener("resize", this.sizing);
    window.addEventListener("scroll", this.scrollBg);

    /* set lineup menu activeItem to the url it loaded on */
    let lineupLinksPublished = this.lineup_nav_links_published;
    if (this.$route.hash) {
      let activeItem = this.lineup_nav_links_published.filter(function(item) {
        if (item.link == "/schedule/" + window.location.hash) {
          //console.log('window.location.hash: ', window.location.hash);
          return item;
        }
      });
      var filterIndex = this.lineup_nav_links_published.findIndex(function(
        item
      ) {
        return item.link == activeItem[0].link;
      });
      this.activeItemIndex = filterIndex;
    } else {
      this.activeItemIndex = 0;
    }
  },
  beforeMount() {
    //
  },
  mounted() {
    this.$nextTick(() => {
      /* DOSTUFF EMBED INJECT */
      const embedLink = !this.page.is_dostuff_schedule_live
        ? this.previewLink
        : this.liveLink;

      if (document.getElementById("ds-fest-lineup-js")) {
        //console.log('1.1 element exists');
      } else {
        //console.log('1.2 element does not exist!');
        var element = document.getElementById("dostuff-embed-container");
        let dostuffEmbedProd = document.createElement("script");
        dostuffEmbedProd.setAttribute("id", "dostuff-js");
        dostuffEmbedProd.setAttribute("type", "text/javascript");
        dostuffEmbedProd.setAttribute("ref", "myDiv");
        dostuffEmbedProd.setAttribute("src", embedLink);
        element.appendChild(dostuffEmbedProd);
        //console.log('1.4 lineup embed - created() ');
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to) {
      console.log("Schedule - beforeRouteUpdate");
    } else {
      console.log("else Schedule - beforeRouteUpdate");
    }
  },
  watch: {
    $route(to, from) {
      //
    }
  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener("load", this.sizing);
    window.removeEventListener("resize", this.sizing);
    window.removeEventListener("scroll", this.scrollBg);
  }
};
</script>
